import React from "react";
import QrCodeGenerator from "../../Admin/GenerateQrcode/QrCodeGenerator";
import ConferancePage from "./ConferancePage";
import InstituteRegistrationForm from "./InstituteRegistrationForm";

const InstituteSignupForm = () => {
  return (
    <>
      <InstituteRegistrationForm />
    </>
  );
};

export default InstituteSignupForm;
